import React from "react";
var __jsx = React.createElement;
import stl from "./BuyItWeDeliverItSingle.module.css";
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
var BuyItWeDeliverItSingle = function BuyItWeDeliverItSingle(_ref) {
  var cityName = _ref.cityName;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.BDC_container
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.BDC_content
  }, /*#__PURE__*/React.createElement("h2", null, t("اشتريها و نوصلها لباب بيتك في {{cityName}}", {
    ns: "web_city",
    cityName: cityName
  })), /*#__PURE__*/React.createElement("p", null, t("من خلال شاحنات شركة سيارة الحديثة نوفر خدمات إيصال السيارة المراد شرائها لين باب بيتك لضمان الراحة الكاملة التي نسعى لتوفيرها في أي مكان داخل منطقة {{cityName}} وكافة المحافظات السعودية", {
    ns: "web_city",
    cityName: cityName
  }))), /*#__PURE__*/React.createElement("div", {
    className: stl.BDC_imageContainer
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/city/buy_it_we_deliver_it.webp",
    alt: "biggest collection of cars image",
    loading: "lazy",
    width: 450,
    height: 200
  }))));
};
export default BuyItWeDeliverItSingle;